var map = {
	"./aircon-truck.png": 1219,
	"./airstarter.png": 1220,
	"./airtug.png": 1221,
	"./ambulance.png": 1222,
	"./bed.png": 1223,
	"./bicycle.png": 1224,
	"./boom-lift.png": 1225,
	"./bowser.png": 1226,
	"./boy.png": 1227,
	"./bulldozer.png": 1228,
	"./bus.png": 1229,
	"./car.png": 1230,
	"./catering-hi-lift.png": 1231,
	"./cement-mixer.png": 1232,
	"./crane.png": 1233,
	"./defueller.png": 1234,
	"./excavator.png": 1235,
	"./female.png": 1236,
	"./fire-tender.png": 1237,
	"./forklift.png": 1238,
	"./galley-cart.png": 1239,
	"./garbage-wagon.png": 1240,
	"./girl.png": 1241,
	"./helmet.png": 1242,
	"./infant.png": 1243,
	"./invalid-passenger-lift.png": 1244,
	"./joint-pallet-container-loader.png": 1245,
	"./lavatory-truck.png": 1246,
	"./lorry.png": 1247,
	"./maintenance-platform.png": 1248,
	"./male.png": 1249,
	"./mechanical-sweeper.png": 1250,
	"./mini-bus.png": 1251,
	"./mobile-gpu.png": 1252,
	"./motorcycle.png": 1253,
	"./others.png": 1254,
	"./passenger-step.png": 1255,
	"./pmd.png": 1256,
	"./police-car.png": 1257,
	"./prime-mover.png": 1258,
	"./recovery-truck.png": 1259,
	"./scissor-lift.png": 1260,
	"./scooter.png": 1261,
	"./scrubber.png": 1262,
	"./seatbelt.png": 1263,
	"./ship.png": 1264,
	"./skyloader.png": 1265,
	"./storage-bin.png": 1266,
	"./tanker.png": 1267,
	"./tractor.png": 1268,
	"./trailer.png": 1269,
	"./tram.png": 1270,
	"./transporter.png": 1271,
	"./van.png": 1272,
	"./water-truck.png": 1273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1218;